(ns global.endor.checkout.core
  {:clj-kondo/config '{:linters {:clojure-lsp/unused-public-var {:level :off}}}}
  (:require [global.endor.checkout.router :as router]
            [global.endor.checkout.stripe.core :as stripe]
            [global.endor.checkout.ui.core :as ui]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.dom]
            [re-frame.uix :refer [use-subscribe]]
            [day8.re-frame.async-flow-fx]))

(def routes
  [["/checkout"
    {:name :stripe
     :view stripe/stripe
     :on-navigate [::stripe/create-checkout-session]}]
   ["/checkout-complete"
    {:name :checkout-complete
     :view stripe/complete}]])

(defui app []
  (when-let [view (use-subscribe [::router/current-view-component])]
    ($ ui/container
       ($ view))))

(defonce root
  (uix.dom/create-root (js/document.getElementById "root")))

(defn render []
  (uix.dom/render-root
   ($ uix/strict-mode
      ($ app))
   root))

(defn ^:export init []
  (js/console.log "init app")
  (rf/dispatch [::router/init routes])
  (rf/dispatch [::stripe/init])
  (render))

#_{:clojure-lsp/ignore [:clojure-lsp/unused-public-var]}
(defn ^:dev/after-load reload []
  (js/console.log "reload app")
  (render))
